/**
 * Error Interceptor — capture Sentry des échecs HTTP infrastructure
 * (status 0 = réseau/CORS, >= 500 = erreur serveur), puis re-propage
 * l'erreur inchangée aux facades. Les 4xx sont des réponses métier
 * attendues (validation, droits) : pas de Sentry.
 */

import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MonitoringService } from '../monitoring/monitoring.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly monitoring = inject(MonitoringService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && (error.status === 0 || error.status >= 500)) {
          this.monitoring.captureHttpError(error, request.method, request.urlWithParams);
        }
        return throwError(() => error);
      })
    );
  }
}

